<!--
 * @Author: Junjie
 * @Date: 2023-01-13 10:45:50
 * @LastEditTime: 2023-01-13 12:36:24
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/monitor/points/ImportantPoints.vue
-->
<template>
  <div class="page-container flex flex-col">
    <div :class="['flex-1']">
      <template>
        <iframe-f-report-view
          :mozallowfullscreen="true"
          :msallowfullscreen="true"
          :oallowfullscreen="true"
          :src="iframeSrc"
          allowfullscreen="true"
          frameborder="0"
          ref="commentIframe"
          webkitallowfullscreen="true"
        ></iframe-f-report-view>
      </template>
    </div>
    <a-row style="padding-top: 10px;text-align: center;">
      <a-col :span="24">
        <a-radio-group @change="loadPage" buttonStyle="solid" v-model="curReport">
          <a-radio-button :key="item.id" :value="key" v-for="(item, key) in reports">{{ item.label }}</a-radio-button>
        </a-radio-group>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { getAction, httpAction } from '@/api/manage'
import IframeFReportView from '@/components/layouts/IframeFReportView.vue'

export default {
  name: 'MultiEmbedPage',
  components: {
    IframeFReportView
  },
  data() {
    return {
      description: '多页面嵌入',
      iframeSrc: '',
      reports: [],
      curReport: 0,
      url: {
        getReportList: '/custom/commonOnlReport/list'
      }
    }
  },
  created() {
    this.getReportList()
  },
  methods: {
    loadPage() {
      let linkUrl = this.reports[this.curReport].url
      this.iframeSrc = linkUrl
    },
    getReportList() {
      const parms = {
        reportGroup: 'emb-topo',
        pageSize: 9999,
        clientDevice: 'PC',
        isDisplay: 'Y',
        column: 'orderNum',
        order: 'asc'
      }
      getAction(this.url.getReportList, parms).then(res => {
        if (res.success) {
          res.result.records.forEach(report => {
            this.reports.push({
              label: report.reportName,
              value: report.id,
              url: report.url
            })
          })
          this.loadPage()
        }
      })
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

iframe {
  height: 100%;
}

</style>
